// extracted by mini-css-extract-plugin
module.exports = {"main-content":"Footer_main-content__soPp3","footer":"Footer_footer__21T4O","footerContainer":"Footer_footerContainer__2hHIO"};